<template>
<el-drawer
  :visible.sync="show"
  direction="rtl"
  size="50%"
  :withHeader="false"
  :close-on-press-escape="false"
  :before-close="close">
  <div class="pd-10-20">
    <!-- <el-divider content-position="left">基本信息</el-divider> -->
    <el-form :model="formData" label-width="80px" size="small">
      
      <el-form-item label="">
        <Resources :list="formData.resources"/>
      </el-form-item>
      <el-form-item label="发布时间">
        <el-date-picker
          v-model="formData.publishDate"
          type="datetime"
          placeholder="选择日期时间">
        </el-date-picker>
        <el-button class="ml-10" type="" @click="doSetCurrentTime">设为当前</el-button>
        <el-button type="" @click="doReset">恢复之前</el-button>
      </el-form-item>
      <el-form-item label="帖子标题">
        <el-input v-model="formData.title" autocomplete="off" style="width:100%" :readonly="isSubmitLoading"></el-input>
        
      </el-form-item>
      <el-form-item label="帖子内容">
        <el-input v-model="formData.contents" type="textarea" :rows="5" autocomplete="off" style="width:100%" :readonly="isSubmitLoading"></el-input>
        
      </el-form-item>
      <el-form-item label="" class="ta-r">
        <el-button icon="el-icon-position" type="primary" @click="doSubmitAndPush" :loading="isSubmitLoading">发布</el-button>
        <el-button type="" @click="doSubmit" :loading="isSubmitLoading">仅保存</el-button>
      </el-form-item>

              


    </el-form>
    <!-- <div slot="footer" class="dialog-footer">
      <el-button @click="close">跳过,稍候再设</el-button>
      <el-button type="primary" @click="doSubmit">保 存</el-button>
    </div> -->
  </div>
</el-drawer>

</template>

<script>
import Resources from '@/components/Resources';
export default {
  name: 'PostEdit',
  props: {
    data: Object,
    show: Boolean,
    doChangePage:{
      type:Function,
      default:()=>{}
    }
  },
  components: {
    Resources
  },
  data(){
    return {
      formData:{
        ...this.data //,title:this.data.title+(this.data.contents?('\n'+this.data.contents):''),contents:''
      },
      isSubmitLoading:false,
    }
  },
  watch: {
    data(newData){
      var data = this.$root.copy({
        ...newData //,title:newData.title+(newData.contents?('\n'+newData.contents):''),contents:''
      });

      this.formData = data;
    }
  },
  
  methods:{
    doSetCurrentTime(){
      this.formData.publishDate = this.$root.format();
    },

    doReset(){
      this.formData.publishDate = this.data.publishDate;
    },

    close(){
      this.$emit('update:show',false);
      this.doChangePage(1);
    },

    async doSubmitAndPush(){
      var result = await this.doSubmit(false);
      if(result){
        await this.request.post(`/api/v1/postings/syncing/${this.formData.postingId}`,{postingId:this.formData.postingId}).then(async res=>{
          this.isSyncIdLoading = 0;
          if(!res){return ;}
          this.$message.success("创建发布帖子任务成功!");
          this.$emit('update:currnetData',{...this.data,isWaiting:true});
          setTimeout(() => {
            this.close();
          }, 3000);
        })
      }
    },
    async doSubmit(showMessage){
      this.isSubmitLoading = true;
      return await this.request.put(`/api/v1/postings/${this.formData.postingId}`,{...this.formData}).then(async res=>{
        
        this.isSubmitLoading = false;
        if(!res){return false;}
        if(showMessage)this.$message.success("更新成功");
        this.close();
        return res;
      });


    }
  },
}
</script>

<style scoped lang="less">
.uploadBox{
  text-align: center;
  background: #C0C4CC;
  border-radius: 50%;
  width:60px;
  height:60px;
  font-size:26px;
  color:#fff;
  line-height: 1;
  overflow: hidden;
  position: relative;
  .icon{
    margin-top:5px;
    width: 100%;
  }
  .text{
    width: 100%;
    font-size:12px;
  }
  
}
.avatar-uploader{
  opacity: 0;
  -webkit-transition: opacity .3s;  
  -moz-transition: opacity .3s;  
  -ms-transition: opacity .3s;  
  -o-transition: opacity .3s;  
  transition: opacity .3s;  
  position: absolute;
  top: 0px;
  font-size:30px;
  text-align: center;
  left: 0;
  right: 0;
  bottom:0;
  cursor: pointer;
  color:#aaa;
  &:hover{
    opacity: 1;
  }
  &::before{
    content:"";
    z-index: 1;
    font-size: 0;
    border-radius: 50%;
    position: absolute;
    top:0;left:0;right:0;bottom:0;
    background: rgba(0, 0, 0, .5);
  }
}

input[type='file']{
  opacity: 0;
  z-index: 3;
  cursor: pointer;
  position: absolute;
  top:0;left:0;right:0;bottom:0;
}

.uploadBoxInAvatar{
  opacity: 1;
  z-index: 2;
  position: absolute;
  left: 50%;top:50%;
  transform: translateX(-50%) translateY(-50%);
}
</style>
